import { BaseClient } from 'src/common-services/clients/base-client'
import {
  CreateReportThemeRequest,
  CreateReportThemeResponse,
  GetReportThemesResponse,
  UpdateReportThemeRequest,
  UpdateReportThemeResponse,
} from 'src/types/report-branding'

export class ReportThemesClient extends BaseClient {
  createReportTheme(request: Omit<CreateReportThemeRequest, 'userId'>): Promise<CreateReportThemeResponse> {
    return this.call<CreateReportThemeResponse>('/report-themes', 'POST', { data: request })
  }
  getReportThemes(): Promise<GetReportThemesResponse> {
    return this.call<GetReportThemesResponse>(`/report-themes`, 'GET')
  }
  updateReportTheme(request: UpdateReportThemeRequest): Promise<UpdateReportThemeResponse> {
    return this.call<UpdateReportThemeResponse>(`/report-themes/${request.id}`, 'PUT', { data: request })
  }
  deleteReportTheme(request: { id: string }): Promise<void> {
    return this.call<void>(`/report-themes/${request.id}`, 'DELETE')
  }
}
